import { cn } from '@/lib/utils';

const priorityConfig: Record<string, { text: string; bg: string }> = {
  low:      { text: '#2563EB', bg: '#DBEAFE' },
  medium:   { text: '#D97706', bg: '#FEF3C7' },
  high:     { text: '#DC2626', bg: '#FEE2E2' },
  critical: { text: '#7C2D12', bg: '#FEE2E2' },
};

interface PriorityBadgeProps {
  priority: string;
  className?: string;
}

export function PriorityBadge({ priority, className }: PriorityBadgeProps) {
  const config = priorityConfig[priority] ?? priorityConfig.medium!;
  return (
    <span
      className={cn('inline-flex items-center rounded px-2 py-0.5 text-xs font-medium', className)}
      style={{ color: config.text, backgroundColor: config.bg }}
    >
      {priority.charAt(0).toUpperCase() + priority.slice(1)}
    </span>
  );
}
